<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                Historiques des paiements
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="balance_stories"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="balanceloading"
                                    loading-text="Chargement en cours...">

                                <template v-slot:item.code="{ item }">
                                    <v-chip  dark>{{ item.code }}</v-chip>
                                </template>
                                <template v-slot:item.pharmacie_slug="{item}">
                                    {{ item.pharmacie_slug.nom}}
                                </template>
                                <template v-slot:item.type="{item}">
                                    <div v-if='item.type==="Débiter"'>
                                        <v-chip color="red" dark>{{item.type}}</v-chip>

                                    </div>
                                    <div v-else-if='item.type==="Créditer"'>
                                        <v-chip color="green" dark>{{item.type}}</v-chip>
                                    </div>
                                </template>
                                <template v-slot:item.ask_paiement_slug="{item}">
                                    {{ item.ask_paiement_slug.phone_receiver}}
                                </template>
                                <template v-slot:item.montant="{item}">
                                    <v-chip  dark>{{ item.montant +" FCFA" }}</v-chip>
                                </template>
                                <template v-slot:item.created_at="{item}">
                                    {{ getformatDate(item.created_at)}}
                                </template>
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="500px">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field
                                                                        clearable :rules="libelRules" v-model="editedItem.nom"
                                                                        label="Nom" placeholder="ex : Comprimé"></v-text-field>
                                                            </v-col>


                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1"  :disabled="!valid" text >Sauvegarder</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "BalanceStorie",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                headers: [
                    {
                        text: 'Pharmancie',
                        align: 'start',
                        sortable: true,
                        value: 'pharmacie_slug',
                    },
                    {text: 'Montant', value: 'montant'},
                    {text: 'Type', value: 'type'},
                    {text: 'Numero de reception', value: 'ask_paiement_slug'},
                    {text: 'Opération éffectué le :', value: 'created_at'},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle forme" : "Mise à jour"
            }
            ,
            ...mapState('balance_stories/', ['balance_stories','balanceloading'])

        }
        ,
        mounted() {
        window.scrollTo(0,0);
            this.$store.dispatch('balance_stories/get').then(response => {
                window.console.log('balance_stories', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },


            editItem(item) {
                this.editedIndex = this.balance_stories.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>